module.exports = __webpack_public_path__ + "cbbb58e182e6c1171705abb9b11e1810.svg";